import Lastmenu2 from "./LastMenu2";
import you from '../images/boy.png';
import bot from '../images/happy.png';
import { useState } from "react";

const Plants = () =>{
  const [time] =useState(new Date());
    return(
        <>
        <div className="you-time animated-frame">
              <img src={you} alt="boy" className="boy" />
              You {time?.toLocaleTimeString()}</div>
            <div className="you-message">
              <div className="frame2 animated-frame"><b>Our Plants</b></div>
            </div>

            <div className='chatbot'>
              <img src={bot} alt="bot" className="bot" />
              <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
            </div>
           <div className="frame1 animated-frame">
  {/* <div className="box2" style={{ marginLeft: "32px" }}> */}
    The company operates 4 milk processing and packaging plants spread across various places in Telangana, 
    Andhra Pradesh, Tamil Nadu, and Karnataka states. The plant locations are Gundrampally, Nellore, Palamaner, Chendurthi.
    <div className="plants">
      <div className="plant1"></div>
      <div className="plant2"></div>
      <div className="plant3"></div>
      <div className="plant4"></div>
    </div>
  </div>
{/* </div> */}
<Lastmenu2 />
        </>
    );
}
export default Plants;